// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\r\n  /*50 = navbar  */\r\n  min-height: calc(100vh - 57px);\r\n  width: 100%;\r\n  position: relative;\r\n  overflow: hidden;\n}\n.fixed-header+.app-main[data-v-078753dd] {\r\n  padding-top: 50px;\n}\r\n", ""]);
// Exports
module.exports = exports;
